import { Button, type ButtonProps } from "@mantine/core";

type Props = Omit<ButtonProps, "variant" | "color"> & {
  onClick?: () => void;
  type?: "button" | "submit";
};

export function QuietButton({ children, ...rest }: Props) {
  return (
    <Button variant="subtle" color="brass" {...rest}>
      {children}
    </Button>
  );
}
